module.exports = __webpack_public_path__ + "img/reduce.b1851188.svg";